<template>
    <div class="row">
        <div class="col-5">
            <q-input
                    v-model="qbCustomerId"
                    type="number"
                    name="quickbooksId"
                    class="no-shadow"
                    hide-underline
                    inverted-light
                    :color="inputBgColor"
                    @input="updateParent"
            />
        </div>
        <!-- <div class="col-3">
          <q-btn label="Add" icon="add_box" color="positive" class="full-width" @click="handleAdd">
            <q-tooltip>Add Quickbooks</q-tooltip>
          </q-btn>
        </div>-->
        <div class="col-3">
            <q-btn
                    label="Match"
                    icon="compare_arrows"
                    color="primary"
                    class="full-width"
                    @click="handleMatch"
            >
                <q-tooltip>Match with existing Quickbooks record</q-tooltip>
            </q-btn>
        </div>
        <div class="col-4">
            <q-btn
                    label="View/Edit Customer"
                    icon="business"
                    color="secondary"
                    class="full-width"
                    @click="externalLink(`customerdetail?nameId=${qbCustomerId}`)"
                    :disable="!qbCustomerId"
            >
            </q-btn>
        </div>
        <q-modal v-model="modalOpen" content-classes="q-pa-lg" content-css="min-width: 70%">
            <h4>Find Quickbooks Record to Match</h4>
            <q-table
                    ref="table"
                    :data="serverData"
                    title="Quickbook Records"
                    :columns="columns"
                    :filter="filter"
                    row-key="name"
                    :pagination.sync="serverPagination"
                    :loading="loading"
                    @request="request"
            >
                <template slot="top-right" slot-scope="props">
                    <q-search hide-underline v-model="filter"/>
                </template>
                <q-tr slot="body" slot-scope="props" :props="props">
                    <q-td key="fullyQualifiedName" :props="props">{{ props.row.fullyQualifiedName }}</q-td>
                    <q-td key="id" :props="props">{{ props.row.id }}</q-td>
                    <q-td key="select" :props="props">
                        <q-btn label="Select" color="primary" @click="handleSelect(props.row.id)"/>
                    </q-td>
                </q-tr>
            </q-table>
            <q-btn class="q-mt-lg" color="primary" @click="modalOpen = false" label="Close"/>
        </q-modal>
    </div>
</template>
<script>
import colorsMixin from '../../mixins/colors'
import environmentMixin from '../../mixins/environment'
import { openURL } from 'quasar'

export default {
  name: 'QuickbooksId',
  mixins: [colorsMixin, environmentMixin],
  props: {
    value: {
      type: String,
      default: ''
    },
    column: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      qbCustomerId: undefined,
      modalOpen: false,
      filter: '',
      loading: false,
      serverPagination: {
        page: 1,
        rowsNumber: 50 // specifying this determines pagination is server-side
      },
      serverData: [],
      columns: [
        {
          name: 'fullyQualifiedName',
          required: true,
          label: 'Name',
          // align: 'left',
          field: 'fullyQualifiedName',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'id',
          required: true,
          label: 'QB Customer ID',
          // align: 'left',
          field: 'id',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'select',
          required: true,
          label: '',
          // align: 'left',
          field: 'id',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        }
      ]
    }
  },
  methods: {
    externalLink (url) {
      let finalUrl = this.quickbooksBaseUrl + url
      openURL(finalUrl)
    },
    updateParent (value) {
      this.$emit('manual-update', this.column.field, parseInt(value))
    },
    handleSelect (id) {
      // console.log('handleSelect', id)
      this.qbCustomerId = parseInt(id)
      this.modalOpen = false
      this.updateParent(parseInt(id))
    },
    handleAdd () {
    },
    handleMatch () {
      this.request({
        pagination: this.serverPagination,
        filter: this.filter
      })
      this.modalOpen = true
    },
    async request ({pagination, filter}) {
      this.loading = true

      try {
        // const {data} = await this.$axios.get(`/api/quickbooksaccounting/customer/pages/${pagination.page}?sortBy=${pagination.sortBy}&descending=${pagination.descending}&filter=${filter}`)
        const {data} = await this.$axios.get('/api/quickbooksaccounting/customer/pages/')
        // const {data} = await this.$axios.get('/api/quickbooksaccounting/customer/list')
        if (data) {
          // updating pagination to reflect in the UI
          this.serverPagination = pagination
          // we also set (or update) rowsNumber
          this.serverPagination.rowsNumber = data.rowsNumber
          // then we update the rows with the fetched ones
          this.serverData = data.data
          // finally we tell QTable to exit the "loading" state
          this.loading = false
        } else {
          this.$q.notify({
            message: 'Error fetching Quickbook Records 1'
          })
          this.ready = true
          this.loading = false
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching Quickbook Records 2'
        })
        this.loading = false
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        this.qbCustomerId = v
      },
      immediate: true
    }
  }
  // mounted () {
  //   // once mounted, we need to trigger the initial server data fetch
  //   this.request({
  //       pagination: this.serverPagination,
  //       filter: this.filter
  //     })
  // },
  // created () {
  //   // console.log('QB: ', this.value)
  // },
  // watch: {
  //   value: {
  //     handler (newValue) {
  //       this.$set(this, 'qbCustomerId', newValue)
  //     },
  //     immediate: true
  //   }
  // }
}
</script>
